import { type GkAirProxyServiceWebResponseRecommendationsValue } from '@redteclab/api/clients/crosssellers-proxy-service'

export const recommendationAccessorGetWidgetAdServerMetadata = ({
  widgetData,
}: {
  widgetData: GkAirProxyServiceWebResponseRecommendationsValue | undefined
}):
  | GkAirProxyServiceWebResponseRecommendationsValue['adServerMetadata']
  | undefined => {
  return widgetData?.adServerMetadata
}
